// API Configuration
// This file centralizes all API endpoints and can be easily modified

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

export const API_CONFIG = {
  BASE_URL: API_BASE_URL,
  AUTH: {
    BASE: `${API_BASE_URL}/auth`,
    LOGIN: `${API_BASE_URL}/auth/login`,
    SIGNUP: `${API_BASE_URL}/auth/signup`,
    REFRESH: `${API_BASE_URL}/auth/refresh`,
    CONFIRM: `${API_BASE_URL}/auth/confirm`,
  },
  STOCK: {
    BASE: `${API_BASE_URL}/stock`,
    GRAPH: (symbol: string, timeframe: string | number) =>
      `${API_BASE_URL}/stock/${encodeURIComponent(symbol)}/graph?timeframe=${encodeURIComponent(String(timeframe))}`,
    NEWS: (symbol: string) => `${API_BASE_URL}/stock/${encodeURIComponent(symbol)}/news`,
    OVERVIEW: (symbol: string) => `${API_BASE_URL}/stock/${encodeURIComponent(symbol)}/overview`,
    STATISTICS: (symbol: string) => `${API_BASE_URL}/stock/${encodeURIComponent(symbol)}/statistics`,
    QUOTE: (symbol: string) => `${API_BASE_URL}/stock/${encodeURIComponent(symbol)}/quote`,
  },
  DASHBOARD: {
    BASE: `${API_BASE_URL}/dashboard`,
    BOOTSTRAP: `${API_BASE_URL}/dashboard/bootstrap`,
    GRAPH: (portfolioId: string) => `${API_BASE_URL}/dashboard/${portfolioId}/graph`,
    NEWS: (portfolioId: string) => `${API_BASE_URL}/dashboard/${portfolioId}/news`,
    PROCESSED: (portfolioId: string) => `${API_BASE_URL}/dashboard/${portfolioId}/processed`,
    BUY: (portfolioId: string) => `${API_BASE_URL}/dashboard/${portfolioId}/buy`,
    CHANGE_MAIN: (portfolioId: string) => `${API_BASE_URL}/dashboard/${portfolioId}/changeMainPortfolio`,
    PORTFOLIO: (portfolioId: string) => `${API_BASE_URL}/dashboard/${portfolioId}/portfolio`,
  },
  PAYMENT: {
    BASE: `${API_BASE_URL}/payment`,
    CREATE_CHECKOUT: `${API_BASE_URL}/payment/create-checkout-session`,
    CREATE_PORTAL: `${API_BASE_URL}/payment/create-portal-session`,
    SUBSCRIPTION: `${API_BASE_URL}/payment/subscription`,
    WEBHOOK: `${API_BASE_URL}/payment/webhook`,
  },
  USERS: {
    BASE: `${API_BASE_URL}/users`,
    GET_USER: (userId: string) => `${API_BASE_URL}/users/${userId}`,
    REMOVE_TICKERS: (userId: string, portfolioId: string) => `${API_BASE_URL}/users/${userId}/${portfolioId}/remove-tickers`,
  },
  ML: {
    BASE: `${API_BASE_URL}/ml`,
    GENERATE_PORTFOLIO: `${API_BASE_URL}/ml/generate-portfolio`,
    HEALTH: `${API_BASE_URL}/ml/health`,
  },
  HEALTH: `${API_BASE_URL}/health`,
  WAITLIST: {
    CREATE: `${API_BASE_URL}/public/waitlist`,
    STATS: `${API_BASE_URL}/public/waitlist/stats`,
    REF: (code: string) => `${API_BASE_URL}/public/waitlist/ref/${encodeURIComponent(code)}`,
    UNSUBSCRIBE: `${API_BASE_URL}/public/waitlist/unsubscribe`,
  },
};

// Development vs Production configuration
export const isDevelopment = process.env.NODE_ENV === 'development';
export const isProduction = process.env.NODE_ENV === 'production';

// API configuration is set based on environment variables
